jQuery( ( $ ) => {

	const mainBasket = $( '.basket-main' );

	$( '.close', mainBasket ).click( function( event ) {
		event.preventDefault();
		const form = $( this ).closest( 'form' );

		if( $( this ).hasClass( 'mobile' ) ) {
			$( this ).closest( '.basket-small' ).remove();
		} else {
			$( this ).closest( 'tr' ).remove();
		}

		submitBasketForm( form );
	} );

	$( '.coucher-link li a', mainBasket ).click( function( event ){
		event.preventDefault();
		$( '.form-inline' ).addClass( 'd-none' );
		if( 'donation' === $( this ).data( 'show' ) ) {
			$( `.table.${  $( this ).data( 'show' )}` ).removeClass( 'd-none' );
		} else {
			$( `.form-inline.${  $( this ).data( 'show' )}` ).removeClass( 'd-none' );
		}
	} );

	$( '.add-donation', mainBasket ).click( function( ){
		const $this = $( this );
		$this.closest( 'table' ).find( 'tr.don-row' ).not( `[data-ref="${$this.closest( 'tr' ).data( 'ref' )}"]` ).remove();
		$( '#add-donation-spinner' ).removeClass( 'd-none' );
		$( '#add-donation-text' ).addClass( 'd-none' );
	} );






	$( 'div.qty input, .select-options', mainBasket ).change( function() {
		submitBasketForm( $( this ).closest( 'form' ) );
	} );

	function submitBasketForm( form ) {
		$( 'a.close', form ).off( 'click' );

		$( 'div.qty input,select', form ).each( function () {
			const name = $( this ).attr( 'name' );
			const value = $( this ).val();

			$( this ).after( `<input type="hidden" name="${name}" value="${value}">` );
			$( this ).attr( 'disabled', true );
		} );

		form.submit();
	}


	let customerGiftAidDeclaration = false;

	$( '.gift-aid-check1-box' ).click( function() {
		const tick = document.getElementById( 'gift-aid-check1-tick' );
		tick.classList.toggle( 'display-none' );

		if ( false === customerGiftAidDeclaration ){
			customerGiftAidDeclaration = true;
			setGiftAidSession( customerGiftAidDeclaration );
		} else {
			customerGiftAidDeclaration = false;
			setGiftAidSession( customerGiftAidDeclaration );
		}

	} );

	$( '.gift-aid-check1-box-mobile' ).click( function() {
		const tick = document.getElementById( 'mobile-gift-aid-check1-tick' );
		tick.classList.toggle( 'display-none' );

		if ( false === customerGiftAidDeclaration ){
			customerGiftAidDeclaration = true;
			setGiftAidSession( customerGiftAidDeclaration );

		} else {
			customerGiftAidDeclaration = false;
			setGiftAidSession( customerGiftAidDeclaration );
		}
	} );

	function setGiftAidSession( declaration ){
		const formData = new FormData();
		formData.append( 'action', 'do_create_gift_aid_declaration' );
		formData.append( 'gift_aid_declaration', declaration );
		$.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} );
	}

	$( '#remove-performance' ).click( function ( e ) {
		e.preventDefault();
		$( 'input[name="removePerformanceId"]' ).val( $( this ).data( 'value' ) );
		$( this ).closest( 'form' ).submit();
	} );

	$( '#continue-to-payment-btn' ).click( function( ) {
		if ( $( '#accessNote' ).val() ){
			setAccessRequirement();
		}
	} );


	function setAccessRequirement() {
		const accessRequirementNotes = $( '#accessNote' ).val();
		const formData = new FormData();
		formData.append( 'action', 'do_set_access_requirement' );
		formData.append( 'access_requirement_notes', accessRequirementNotes );

		$.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} );
	}

	$( '.center' ).slick( {
		arrows: true,
		nextArrow: '<button type="button" class="related-merch-carousel-icon-next related-merch-carousel-icon"></button>',
		prevArrow: '<button type="button" class="related-merch-carousel-icon-prev related-merch-carousel-icon"></button>',
		centerPadding: '60px',
		slidesToShow: 4,
		dots: false,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					centerMode: true,
					centerPadding: '40px',
					variableWidth: true,
					infinite: false,
					arrows: true,
					speed: 300,
					slidesToShow: 2
				}
			},
			{
				breakpoint: 565,
				settings: {
					arrows: true,
					centerMode: true,
					centerPadding: '40px',
					variableWidth: true,
					slidesToShow: 1
				}
			}
		]
	} );

	$( '.one-time' ).slick( {
		dots: false,
		infinite: true,
		nextArrow: '<button type="button" class="related-merch-carousel-icon-next related-merch-carousel-icon-next-mob related-merch-carousel-icon"></button>',
		prevArrow: '<button type="button" class="related-merch-carousel-icon-prev related-merch-carousel-icon"></button>',
		speed: 300,
		slidesToShow: 1,
		adaptiveHeight: true
	} );

	$( '.related-merch-card select' ).change( function() {
		if ( 0 != this.value ) {
			$( this )
				.closest( '.related-merch-card' )
				.find( '.related-merch-add-to-basket' )
				.removeClass( 'disabled-btn-state' )
				.prop( 'disabled', false );
		}
		else {
			$( this ).closest( '.related-merch-card' )
				.find( '.related-merch-add-to-basket' )
				.addClass( 'disabled' )
				.prop( 'disabled', true );
		}

	} );

	$( '.related-merch-add-to-basket' ).click( function( ){
		const $this = $( this );
		const selectedItem = $( this ).closest( '.related-merch-card' ).find( '.related-merch-select' ).val();
		this.value = selectedItem;

		const merchCard =  $this.closest( '.related-merch-card' );
		const indexID = merchCard.data( 'merch-code' );
		$this.closest( '.related-merch-carousel-wrapper' ).find( '.rel' ).data( 'merch-code' );
		$this.closest( '.related-merch-carousel-wrapper' ).find( '.related-merch-card' ).not( `[data-merch-code="${indexID}"]` ).empty();

	} );

	$( '.checkout-buttons .btn-hover-darker' ).click( function( ) {
		$( '#checkout-spinner' ).removeClass( 'd-none' );
		$( '#checkout-text' ).addClass( 'd-none' );
		$( window ).on( 'hashchange', function( ){
			$( '#checkout-spinner' ).addClass( 'd-none' );
			$( '#checkout-text' ).removeClass( 'd-none' );
		} );
	} );

	$( '.addVoucher' ).click( function( ) {
		$( '#voucher-spinner' ).removeClass( 'd-none' );
		$( '#voucher-text' ).addClass( 'd-none' );
		$( window ).on( 'hashchange', function( ){
			$( '#voucher-spinner' ).addClass( 'd-none' );
			$( '#voucher-text' ).removeClass( 'd-none' );
		} );
	} );

	$( '.addPromotional' ).click( function( ) {
		$( '#promotional-spinner' ).removeClass( 'd-none' );
		$( '#promotional-text' ).addClass( 'd-none' );
		$( window ).on( 'hashchange', function( ){
			$( '#promotional-spinner' ).addClass( 'd-none' );
			$( '#promotional-text' ).removeClass( 'd-none' );
		} );
	} );

} );


